import React from 'react';
import { motion } from 'framer-motion';
import { UserCircle, Zap, Unlock, ArrowRight } from 'lucide-react';
import { useIsMobile } from '../../hooks/useIsMobile';

const G = '#0F5A3A';

const STEPS = [
  { num: '01', icon: <UserCircle size={26} color={G} />, title: 'Create Your Profile', desc: 'Complete your academic and extracurricular profile. Share your goals, interests, and what matters most to your future.' },
  { num: '02', icon: <Zap size={26} color={G} />, title: 'Get Matched', desc: 'We match you with colleges, scholarships, and smart programs that fit you best.' },
  { num: '03', icon: <Unlock size={26} color={G} />, title: 'Unlock Opportunities', desc: 'Receive personalized offers, alerts, and direct admissions opportunities.' },
];

export const HowItWorks = () => {
  const isMobile = useIsMobile();

  return (
    <section style={{ background: '#fff', padding: isMobile ? '48px 0 40px' : '72px 0 64px' }}>
      <div style={{ maxWidth: '1180px', margin: '0 auto', padding: isMobile ? '0 20px' : '0 40px' }}>
        <div style={{ textAlign: 'center', marginBottom: isMobile ? '32px' : '48px' }}>
          <div style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.14em', color: G }}>HOW IT WORKS</div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr auto 1fr auto 1fr', gap: isMobile ? '24px' : '0', alignItems: isMobile ? 'stretch' : 'start' }}>
          {STEPS.map((step, i) => (
            <React.Fragment key={step.num}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                style={{ padding: isMobile ? '20px' : '0 20px', textAlign: 'left', background: isMobile ? `${G}05` : 'transparent', borderRadius: isMobile ? '12px' : '0' }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
                  <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: G, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <span style={{ fontSize: '12px', fontWeight: 800, color: '#fff' }}>{step.num}</span>
                  </div>
                  <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: `${G}0e`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {step.icon}
                  </div>
                </div>
                <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '1.2rem', fontWeight: 800, color: G, marginBottom: '8px' }}>{step.title}</h3>
                <p style={{ fontSize: '14px', color: '#6E6A61', lineHeight: 1.65, margin: 0 }}>{step.desc}</p>
              </motion.div>
              {i < 2 && !isMobile && (
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', paddingTop: '14px' }}>
                    <div style={{ width: '48px', height: '2px', background: `${G}30` }} />
                    <ArrowRight size={14} color={`${G}70`} style={{ flexShrink: 0 }} />
                  </div>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
